import {createAuthClient} from 'better-auth/vue'
import {magicLinkClient, emailOTPClient, jwtClient, organizationClient} from 'better-auth/client/plugins'

export const authClient = createAuthClient({
  // This safely grabs the baked-in public env variable at build time for SPA mode
  baseURL:
    typeof window !== 'undefined'
      ? window.__NUXT__?.config?.public?.authBaseUrl || 'https://insightsauth.oldhobo.com/'
      : process.env.NUXT_PUBLIC_AUTH_URL,
  fetchOptions: {
    credentials: 'include'
  },
  plugins: [magicLinkClient(), emailOTPClient(), jwtClient(),  organizationClient()]
})
